<div class="field-dialog__content__scroll disabled-content p-24" id="photos-videos" fusePerfectScrollbar>
  <div
    *ngIf="!quotationAttachments?.attachments || !quotationAttachments?.attachments.length"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="font-size-32">attach_file</mat-icon>
    </p>
    <div fxFlex="100" fxLayout="row">
      <span class="h3">{{ 'QUOTATIONS.ATTACHMENTS.NO_DATA' | translate }}</span>
    </div>
  </div>

  <div *ngIf="quotationAttachments?.attachments && quotationAttachments?.attachments.length">
    <div class="mb-16" fxLayout="row" fxLayoutAlign="start">
      <mat-icon class="mr-8">attachment</mat-icon>
      <span>{{ 'QUOTATIONS.ATTACHMENTS.TITLE' | translate }}</span>
    </div>
    <div class="attachment w-100-p" *ngFor="let attachment of quotationAttachments.attachments">
      <div fxLayout="row">
        <div
          *ngIf="attachment.isImage"
          class="attachment__preview"
          [style.backgroundImage]="'url(' + attachment.path + ')'"
        ></div>
        <div *ngIf="!attachment.isImage" class="attachment__preview">
          <i [class]="'angularjs-fuse-icon ' + getIconByAttachmentType(attachment.type) + ' centered-icon'"></i>
        </div>
        <div fxLayout="column">
          <span class="attachment__name">{{ attachment.title || 'Anexo sem título' }}</span>
          <span class="attachment__time">{{ attachment.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          <a class="attachment__link" [href]="attachment.path" target="_blank">{{
            'QUOTATIONS.ATTACHMENTS.SHOW_FILE' | translate
          }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
